import { render, staticRenderFns } from "./policy-item.vue?vue&type=template&id=d9b588e4&scoped=true&"
import script from "./policy-item.vue?vue&type=script&lang=js&"
export * from "./policy-item.vue?vue&type=script&lang=js&"
import style0 from "./policy-item.vue?vue&type=style&index=0&id=d9b588e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9b588e4",
  null
  
)

export default component.exports